import { setIncludeNocacheHeader } from '@/components/commons/apollo.js';
import { createApp } from '../components/app.js';
import Tracking from '@/components/commons/Tracking';
// import LocationService from '@/services/LocationService';

// Check on client if currency in HTML and cookie currency are the same
// if not then reload the page
// if (!!window.__CURRENCY__ && !!LocationService.getCurrencyId() && window.__CURRENCY__ != LocationService.getCurrencyId()) {
//   window.location.reload();
// }

setIncludeNocacheHeader(!!window.__APOLLO_NOCACHE__);

const { app, router } = createApp();

app.config.errorHandler = (err, vm, info) => {
  Tracking.sentryCaptureError(err);
};

router.isReady().then(() => {
  const instance = app.mount('#app');

  // THIS NEEDS TO BE CHECKED WHEN WE GET A PRODUCTION READY VERSION
  app._container._vnode = instance.$.vnode;
});
